<template>
  <div class="integration-information">
    <form
      action="#"
      novalidate
    >
      <div class="form-input-container">
        <ScLabel>{{ $t('account.labels.sellerId') }}</ScLabel>
        <div class="input-container">
          <ScInput
            class="form-input"
            v-model="sellerId"
            :disabled="true"
          />
          <ScTooltip>
            <template #tooltip-trigger>
              <GBox
                @click="copyToClipboard(sellerId)"
                :ml="4"
              >
                <GIcon
                  name="copy"
                  stroke="var(--dark-grey-100)"
                  size="20px"
                  class="copy-icon"
                />
              </GBox>
            </template>
            <template #tooltip-text>
              <span
                v-html="$t('account.copy')"
              />
            </template>
          </ScTooltip>
        </div>
      </div>
      <div class="form-input-container">
        <ScLabel>
          <div class="label-wrapper">
            <div class="label">
              {{ $t('account.labels.apiKey') }}
              <ScTooltip
                class="info-tooltip"
              >
                <template #tooltip-trigger>
                  <GIcon
                    name="info"
                    stroke="var(--light-grey-500)"
                    size="14px"
                    class="info-icon"
                  />
                </template>
                <template #tooltip-text>
                  {{ $t('account.integrationInformationWarningText') }}
                </template>
              </ScTooltip>
            </div>
          </div>
        </ScLabel>
        <div class="input-container">
          <ScPassword
            class="form-input"
            v-model="apiKey"
            :disabled="true"
          />
          <ScTooltip>
            <template #tooltip-trigger>
              <GBox
                @click="copyToClipboard(apiKey)"
                :ml="4"
              >
                <GIcon
                  name="copy"
                  stroke="var(--dark-grey-100)"
                  size="20px"
                  class="copy-icon"
                />
              </GBox>
            </template>
            <template #tooltip-text>
              <span
                v-html="$t('account.copy')"
              />
            </template>
          </ScTooltip>
        </div>
      </div>
      <div class="form-input-container">
        <ScLabel>
          <div class="label-wrapper">
            <div class="label">
              {{ $t('account.labels.apiSecret') }}
              <ScTooltip
                class="info-tooltip"
              >
                <template #tooltip-trigger>
                  <GIcon
                    name="info"
                    stroke="var(--light-grey-500)"
                    size="14px"
                    class="info-icon"
                  />
                </template>
                <template #tooltip-text>
                  {{ $t('account.integrationInformationWarningText') }}
                </template>
              </ScTooltip>
            </div>
          </div>
        </ScLabel>
        <div class="input-container">
          <ScPassword
            class="form-input"
            v-model="apiSecret"
            :disabled="true"
          />
          <ScTooltip>
            <template #tooltip-trigger>
              <GBox
                @click="copyToClipboard(apiSecret)"
                :ml="4"
              >
                <GIcon
                  name="copy"
                  stroke="var(--dark-grey-100)"
                  size="20px"
                  class="copy-icon"
                />
              </GBox>
            </template>
            <template #tooltip-text>
              <span
                v-html="$t('account.copy')"
              />
            </template>
          </ScTooltip>
        </div>
      </div>
      <ScButton
        v-if="editable && !isHiddenUpdateButton"
        @click="showConfirmation(true)"
        class="renew-integration-info-btn"
        type="button"
        variant="secondary"
      >
        {{ $t('account.renewIntegrationInformationBtn') }}
      </ScButton>
      <GAlert v-if="editable && isHiddenUpdateButton">
        Çalışma nedeni ile bir süre güncelleme işlemi gerçekleştirilemiyor.
      </GAlert>
    </form>
    <Confirmation
      :show="confirmation.visibility"
      :dialog="confirmation.text"
      @cancel="showConfirmation(false)"
      @confirm="renewIntegrationInformation"
    />
  </div>
</template>

<script>
import ScTooltip from '@trendyol/sc-ui-kit/ScTooltip';
import ScInput from '@trendyol/sc-ui-kit/ScInput';
import ScButton from '@trendyol/sc-ui-kit/ScButton';
import ScPassword from '@trendyol/sc-ui-kit/ScPassword';
import ScLabel from '@trendyol/sc-ui-kit/ScLabel';
import Confirmation from '@/components/Confirmation/Index';
import utils from '@/utils';
import account from '@/services/account';
import SupplierService from '@/services/SupplierService';
import GIcon from '@trendyol-js/grace/core/GIcon';
import GBox from '@trendyol-js/grace/core/GBox';
import GAlert from '@trendyol-js/grace/core/GAlert';
import { remoteConfig } from '@/services/';

export default {
  name: 'IntegrationInformation',
  components: {
    ScInput,
    ScLabel,
    ScTooltip,
    ScPassword,
    ScButton,
    Confirmation,
    GIcon,
    GBox,
    GAlert,
  },
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      apiKey: '',
      apiSecret: '',
      sellerId: '',
      confirmation: {
        visibility: false,
        text: this.$t('account.renewIntegrationInformationConfirmationText'),
      },
    };
  },
  computed: {
    isMaster () {
      return SupplierService.isMaster();
    },
    isHiddenUpdateButton () {
      return remoteConfig.getConfigValueByKey('HIDE_INTEGRATION_BUTTON', false);
    },
  },
  created () {
    this.getIntegrationInformation();
  },
  methods: {
    showConfirmation (visibility = true) {
      this.confirmation.visibility = visibility;
    },
    async getIntegrationInformation () {
      const integrationInformation = await account.getIntegrationInformationV2();

      this.apiKey = integrationInformation.apiKey;
      this.apiSecret = integrationInformation.apiSecret;
      this.sellerId = integrationInformation.sellerId.toString();
    },
    async renewIntegrationInformation () {
      const integrationInformation = await account.renewIntegrationInformationV2({
        apiKey: this.apiKey,
        apiSecret: this.apiSecret,
      });

      this.apiKey = integrationInformation.apiKey;
      this.apiSecret = integrationInformation.apiSecret;
      this.$toast.success();
    },
    copyToClipboard (text) {
      utils.copyToClipboard(text);
      this.$toast.success(this.$t('account.copyToClipboard'), { duration: 5000 });
    },
  },
};
</script>
<style scoped lang="scss">
  .integration-information{
    width: 33%;

    .form-input-container {
      &:not(:last-child){
        margin-bottom: 16px;
      }

      ::v-deep .mp-label{
        font-size: 14px;
        .icon{
          margin-right: 0;
        }
      }

      .input-container{
        margin-top: 10px;
        width: 100%;
        display: flex;
        align-items: center;
        .-copy-icon{
          margin-left: 4px;
          cursor: pointer;
        }
        .form-input{
          width: 100%;
        }
      }

      .label-wrapper{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .label{
          display: flex;
          align-items: center;
        }
      }
    }
    .info-tooltip {
      & .info-icon {
        margin-left: 5px;
        cursor: pointer;
      }
      &::v-deep .tooltip-text{
        & .arrow:before{
          border-color: #afbbca !important;
        }
        & span {
          width: 300px;
          font-size: 14px;
          line-height: initial;
          background: #afbbca !important;
        }
      }
    }

  }
</style>
